import { render, staticRenderFns } from "./PostJobMenuItem.vue?vue&type=template&id=fff15e4c&scoped=true&"
import script from "./PostJobMenuItem.vue?vue&type=script&lang=js&"
export * from "./PostJobMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff15e4c",
  null
  
)

export default component.exports